;
(function ($) {


!function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
    console.log('define');
  } else {
    factory(root.jQuery);
  }
}(this, function ($) {

  'use strict';

  // Default options
  var defaults = {};



  // Constructor, initialise everything you need here
  var DzJobfilterPlugin = function (element, options) {
    console.log('jobs');

    this.element = element;
    this.options = options;

    this.init();

  };


  // DzMainNavigationPlugin methods and shared properties
  DzJobfilterPlugin.prototype = {

    constructor: DzJobfilterPlugin,

    /** @private */
    init: function () {

      var _self = this;

      $(' .check-none').on('click', function() {
        $(this).parent().next().find('input').removeAttr('checked');
        $('.cb-container input').trigger('change');
      });
      $(' .check-all').on('click', function() {
        $(this).parent().next().find('input').prop('checked', 'checked');
        $('.cb-container input').trigger('change');
      });

      //if ($('.cb-container input').length) {

        $(' .cb-container input').on('change', function() {

          //alert('init jobfilter');

          $.ajax({
            type: "get",
            dataType: "json",
            url: "/mv/jobs/show",
            data: $("#job-filter").serialize()
          })
          .done(function (result) {
              console.log('done');
              // show results
              $('.job-list').html(result.outputList);

              // checkbox status
              var foundLocations = result.foundLocations;
              $('.cb-locations').addClass('inactive');
              for (var i=0; i<foundLocations.length; i++) {
                $('#loc_'+foundLocations[i]).parent().removeClass('inactive');
              }

              var foundJobtypes = result.foundJobtypes;
              $('.cb-jobtypes').addClass('inactive');
              for (var i=0; i<foundJobtypes.length; i++) {
                $('#jt_'+foundJobtypes[i]).parent().removeClass('inactive');
              }

            })
          .error(function (result) {
              alert("Error" + result.test);
          });



        });

      //}


      /*
      if (_self.element.find('.ce_dztabs_item').length <= 1) {
        return;
      }

      _self.element.prepend('<ul class="tabs" data-tab></ul>');
      var tabsUl = _self.element.find('> ul');

      var panelCounter = 1;
      _self.element.find('.ce_dztabs_item').each(function() {
        var panelId = 'panel'+panelCounter;

        var headline = $(this).find('> h4').html();
        $(this).find('> h4').remove();

        var addClass = '';
        if (panelCounter == 1) {
          addClass = 'active';
          $(this).addClass(addClass);
        }

        tabsUl.append('<li class="tab-title '+addClass+'"><a href="#'+panelId+'">'+headline+'</a></li>');

        $(this).attr('id', panelId);
        $(this).addClass('content');


        panelCounter++;
      });



      $(document).foundation('tab', 'reflow');

      */

    }




  };


  /*
   function privateMethod() {
   console.log('Private Method');
   }
   */


  // Create the jQuery DzMainNavigationPlugin
  $.fn.dzJobfilter = function (options) {

    options = $.extend(true, {}, defaults, options);

    return this.each(function () {
      var $this = $(this);
      // Create a new instance for each element in the matched jQuery set
      // Also save the instance so it can be accessed later to use methods/properties etc
      // e.g.
      //    var instance = $('.element').data('plugin');
      //    instance.someMethod();

      $this.data('dzJobs', new DzJobfilterPlugin($this, options));

      //$this.data('testplugin').someMethod();

    });
  };

  // Expose defaults and Constructor (allowing overriding of prototype methods for example)
  $.fn.dzJobfilter.defaults = defaults;
  $.fn.dzJobfilter.DzJobfilterPlugin = DzJobfilterPlugin;

});

}(jQuery));
